(function () {
    'use strict';

    angular
        .module('core.components')
        .controller('NotAuthorizedController', NotAuthorizedController)

    /** @ngInject */
    function NotAuthorizedController($rootScope) {
        const vm = this;

        init();

        function init() {
            $rootScope.alignLayoutCenter = true;
        }
    }
}());